import { render, staticRenderFns } from "./SearchBySerial.vue?vue&type=template&id=84cdd5f0"
import script from "./SearchBySerial.vue?vue&type=script&lang=js"
export * from "./SearchBySerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports